import {formatCurrencyValue} from "../../../../util/PaymentUtils";
import {formatDateMMDDYYYY} from "../../../../util/DateUtils";

export const filterByOptions = [
  { name: "city", label: "City"},
  { name: "state", label: "State"}
];

export const sortByFields = [
  { label: "Supplier", value: "SUPPLIER"},
  { label: "Last Booked Date", value: "LAST_BOOKED"},
  { label: "Daily Price", value: "PRICE_PER_DAY"},
  {label: "Monthly Price", value: "PRICE_PER_MONTH"},
];

export const headCells = [
  {id: "supplier", label: "Supplier Name"},
  {id: "features", label: "Features"},
  {id: "equipmentTypes", label: "Equipment Types"},
  {id: "pricePerMonth", label: "Monthly Rate"},
  {id: "pricePerDay", label: "Daily Rate"},
  {id: "lastBooked", label: "Last Booked Date"},
  {id: "totalBookings", label: "Total Bookings"},
];

export const formatBookedLocations = (locations) => {
  return locations.map(location => ({
    ...location,
    pricePerMonth: formatCurrencyValue(location.pricePerMonth),
    pricePerDay: formatCurrencyValue(location.pricePerDay),
    lastBooked: formatDateMMDDYYYY(location.lastBooked),
    addressLine1: location.address,
  }));
};
